import { render, staticRenderFns } from "./ServiceDelete.vue?vue&type=template&id=de06fa66&scoped=true&"
import script from "./ServiceDelete.vue?vue&type=script&lang=js&"
export * from "./ServiceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de06fa66",
  null
  
)

export default component.exports